import ComponentHeader from '../main/ComponentHeader';
import GruntComponents from '../components';
import {Menu,MenuButton,MenuList,MenuItem,Box,Text, useToast , Badge,Button, Input, InputGroup, InputLeftElement, Spacer, Stack, Table,Thead,Tbody,Tr,Th,Td,TableContainer} from '@chakra-ui/react'
import {SearchIcon, ChevronDownIcon} from '@chakra-ui/icons';
import { loggedOper as lp, colorSchmemes } from '../../util/grunt';
import { useState, useEffect } from "react";
import OsobaControl from './OsobaControl';
import { getOsobe, addOsoba, updateOsoba } from "../../util/apiOsoba";
import GruntPager from '../custom/GruntPager';


const Osobe = ({onClosePress,size='xs'}) => {
    const [state, setState] = useState({newosoba:false,newstranaosoba:false,osobe:[],editosoba:{},fetchosobe:0});
    const [prikaz, setPrikaz] = useState({orderbycol:"id",orderby:"asc",osobeprikaz:[],rowsperpage:100,currpage:1});
    const userCanEdit=lp.uloga==="r"?false:true;
    const toast=useToast();
    const fetchOsobe=async()=>{
        try {
            
            let res=await getOsobe({orderbycolumn:state.orderbycol,orderby:state.orderby});
            if (res.status===200) {
                setState({...state,osobe:res.res});        
                setPrikaz({...prikaz,osobeprikaz:res.res}); 
            } else {
                throw new Error(res.message);
            }
            
        } catch (error) {
            toast({
                title:"Greška kod dohvata podataka.",
                status:"error",
                description:error.message,
                isClosable:true,
                duration:2000,
                position:"top-right",
            });
        }
        
    }

    useEffect(() => {
        fetchOsobe();
        
    }, [state.fetchosobe]);

    useEffect(() => {
        const Sort=()=>{
            const asc=prikaz.orderby==="asc";
            let _b;
            let _os=state.osobe.sort((a,b)=>{
                if (prikaz.orderbycol==="sifra") {
                  _b=a.sifra>b.sifra;
                } else if (prikaz.orderbycol==="naziv") {
                    _b=a.naziv>b.naziv;
                } else if (prikaz.orderbycol==="mjesto") {
                    _b=a.mjesto>b.mjesto;
                } else if (prikaz.orderbycol==="ulkbr") {
                    _b=a.ulkbr>b.ulkbr;
                } else if (prikaz.orderbycol==="pbr") {
                    _b=a.pbr>b.pbr;
                } else if (prikaz.orderbycol==="posta") {
                    _b=a.posta>b.posta;
                } else if (prikaz.orderbycol==="drzava") {
                    _b=a.drzava>b.drzava;
                }

                return asc?(_b?1:-1):(_b?-1:1);
            });
            setPrikaz({...prikaz,osobeprikaz:_os}); 
        }
        Sort();
    }, [prikaz.orderbycol, prikaz.orderby]);
    
    
    const btnNew=()=>{
        if (userCanEdit) {
            return (
                // <Button leftIcon={<SmallAddIcon/>} colorScheme={'grunt2'} variant={'solid'} size={'sm'} 
                // onClick={(e)=>setState({...state,newosoba:true})}>Dodaj</Button>
                <Menu>
                    <MenuButton as={Button} rightIcon={<ChevronDownIcon />} variant={'outline'} colorScheme={'grunt2'} size={size}>
                        Dodaj
                    </MenuButton>
                    <MenuList>
                        <MenuItem fontSize={size} onClick={(e)=>setState({...state,newosoba:true})}>Partner (domaći)</MenuItem>
                        <MenuItem fontSize={size} onClick={(e)=>setState({...state,newstranaosoba:true})}>Partner (strani)</MenuItem>
                    </MenuList>
                </Menu>
                )
        } else {
            return (
                <></>
                )
        }
    }

    const FilterData=(filter)=>{
        const _val=filter.target.value.toLowerCase();
        let _o=state.osobe.filter((osoba)=>{
            return (osoba.sifra.toLowerCase().includes(_val) || osoba.naziv.toLowerCase().includes(_val) || osoba.mjesto.includes(_val) || osoba.ulkbr.includes(_val) || osoba.pbr.toLowerCase().includes(_val) || osoba.posta.toLowerCase().includes(_val) || osoba.drzava.toLowerCase().includes(_val) );
        });
        setPrikaz({...prikaz,osobeprikaz:_o,currpage:1}); 
    }

    const UnosNoveOsobe=()=>{
        if (state.newosoba) {
            return (<OsobaControl vrstaosobe={'fizicka'} osoba={{}} readonly={false} onCloseControl={()=>{setState({...state,newosoba:false})}} onSave={(data)=>SaveOsoba(data)}/>)
        }
        else if (state.newstranaosoba) {
            return (<OsobaControl vrstaosobe={'stranapravna'} osoba={{}} readonly={false} onCloseControl={()=>{setState({...state,newstranaosoba:false})}} onSave={(data)=>SaveOsoba(data)}/>)
        }
    }
    
    const EditOsobe=()=>{
        if (state.editosoba.id!==undefined) {
            let _pravna=state.editosoba.pravna;
            if (state.editosoba.drzava_sifra==="HR") {
                return (<OsobaControl vrstaosobe={_pravna?'pravna':'fizicka'} osoba={state.editosoba} readonly={!userCanEdit} onCloseControl={()=>{setState({...state,editosoba:{}})}} onSave={(data)=>SaveOsoba(data)}/>)    
            } else {
                return (<OsobaControl vrstaosobe={'stranapravna'} osoba={state.editosoba} readonly={!userCanEdit} onCloseControl={()=>{setState({...state,editosoba:{}})}} onSave={(data)=>SaveOsoba(data)}/>)
            }
            
        }
        else {
            return (<></>)
        }
    }

    const SaveOsoba=async (osoba)=>{
            let res;
            
            try {
                if (osoba.id===0) {
                    //dodavanje nove osobe
                    res= await addOsoba(osoba);    
                } else {
                    //ispravak podataka osobe
                    res= await updateOsoba(osoba);
                }
                
                if (res.status===200) {
                    setState({...state,newosoba:false,newstranaosoba:false,editosoba:{},fetchosobe:state.fetchosobe+1});  
                    
                    toast({
                        title:"Podatak spremljen",
                        status:"success",
                        isClosable:true,
                        duration:2000,
                        position:"top-right",
                    });      
                } else {
                    if (res.code==="23505") {
                        throw new Error("Šifra posjednika/osobe već je iskorištena.");    
                    } else {
                        throw new Error(res.message);
                    }
                }

            } catch (erradd) {
                toast({
                    title:"Greška kod unosa",
                    status:"error",
                    description:erradd.message,
                    isClosable:true,
                    duration:3000,
                    position:"top-right",
                });
            }
        
    }

    

    const SelectOsoba=({id,pravna,sifra,mibpg,oib,mb,ime,prezime,naziv,mjesto,ulkbr,pbr,posta,opcina,zupanija,drzava_id,drzava_sifra,drzava})=>{
        let _osoba={};
        _osoba.id=id;
        _osoba.pravna=pravna;
        _osoba.sifra=sifra;
        _osoba.mibpg=mibpg;
        _osoba.oib=oib;
        _osoba.mb=mb;
        _osoba.ime=ime;
        _osoba.prezime=prezime;
        _osoba.naziv=naziv;
        _osoba.mjesto=mjesto;
        _osoba.ulkbr=ulkbr;
        _osoba.pbr=pbr;
        _osoba.posta=posta;
        _osoba.opcina=opcina;
        _osoba.zupanija=zupanija;
        _osoba.drzava_id=drzava_id;
        _osoba.drzava_sifra=drzava_sifra;
        _osoba.drzava=drzava;
        setState({...state,editosoba:_osoba});
    }

    const getOrderImage=(propname)=>{
        let _res=" ⋮";
        if (propname.toLowerCase()===prikaz.orderbycol){
            _res="▴"
            if (prikaz.orderby==="desc") {
                _res="▾"
            }
        } 
        return _res;
    }

    const ShowGruntPager=()=>{
        if (prikaz.osobeprikaz.length>0) {
            return (
                <GruntPager currpage={prikaz.currpage} rowcount={prikaz.osobeprikaz.length} rowsperpage={prikaz.rowsperpage} onClick={(pagenum)=>setPrikaz({...prikaz,currpage:pagenum})}/>
                );    
        }
        
    }
    const showBrZapis=()=>{
        return (
          <Text fontSize={'xs'}>Prikazano zapisa: {state.osobe.length}</Text>
        )
      }
    const getFooter=()=>{
        return (
            
            <Box flexDir={'row'} display={'flex'} w="100%" marginTop={'1.5rem'}>
                
                <Box w="25%">
                    {showBrZapis()}
                </Box>
                <Box w="67%" textAlign={'left'}>
                    {ShowGruntPager()}
                </Box>
                <Box w="25%">
                    
                </Box>
            </Box>
            
        )
    }
    
    return (
        
        //<Box h={'92vh'} key='operateri_component' pl='0.5rem' pr={'0.5rem'}>
        <Box display={'flex'} flexDir={'column'} h={'100%'} borderColor={'silver'} borderBottomRightRadius={'md'} borderWidth={'0.5px'} key='drzave_component' pl='0.5rem' pr={'0.5rem'} pb={'0.2rem'}>
            <ComponentHeader onClosePress={onClosePress} component={GruntComponents.Osobe}/>
            <Box  display={'flex'} alignItems={'center'}>
                    <InputGroup size={'sm'} w='20rem'>
                        <InputLeftElement pointerEvents={'none'} children={<SearchIcon/>}/>
                        <Input focusBorderColor='grunt2.400' placeholder='Filter' maxLength={'20'} onChange={FilterData}/>
                    </InputGroup>
                  
                    {/* <Spacer/> */}
                    <Stack direction={'row'} spacing={'1rem'} mr={'1rem'}>
                        {btnNew()}
                    </Stack>
                    
            
                </Box>
                <Box flexDir={'column'} display={'flex'} flex={1} minH={0} overflow={'hidden'}>
                    <TableContainer overflowY={'auto'} mt={'0.5rem'} flex={1} minH={0}
                        sx={{
                            scrollbarWidth:'none',
                            msOverflowStyle:'none',
                            '&::-webkit-scrollbar':{ display:'none' },
                        }}>
                        <Table variant={'unstyled'} size={'xs'}>
                            <Thead _hover={{cursor:'pointer'}} sx={{ position:'sticky', top:0, zIndex:10 }}>
                                <Tr fontSize={size} bg={'white'}>
                                    <Th textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} borderTopLeftRadius={'sm'}></Th>
                                    <Th textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} onClick={()=>setPrikaz({...prikaz,orderbycol:"sifra",orderby:prikaz.orderby==="asc"?"desc":"asc"})}>Šifra{getOrderImage("sifra")}</Th>
                                    <Th textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} onClick={()=>setPrikaz({...prikaz,orderbycol:"naziv",orderby:prikaz.orderby==="asc"?"desc":"asc"})}>Naziv{getOrderImage("naziv")}</Th>
                                    <Th textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} onClick={()=>setPrikaz({...prikaz,orderbycol:"mjesto",orderby:prikaz.orderby==="asc"?"desc":"asc"})}>Mjesto{getOrderImage("mjesto")}</Th>
                                    <Th textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} onClick={()=>setPrikaz({...prikaz,orderbycol:"ulkbr",orderby:prikaz.orderby==="asc"?"desc":"asc"})}>Ulica i kbr.{getOrderImage("ulkbr")}</Th>
                                    <Th textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} onClick={()=>setPrikaz({...prikaz,orderbycol:"pbr",orderby:prikaz.orderby==="asc"?"desc":"asc"})}>Pošt.br.{getOrderImage("pbr")}</Th>
                                    <Th textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} onClick={()=>setPrikaz({...prikaz,orderbycol:"posta",orderby:prikaz.orderby==="asc"?"desc":"asc"})}>Pošta{getOrderImage("posta")}</Th>
                                    <Th textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} onClick={()=>setPrikaz({...prikaz,orderbycol:"drzava",orderby:prikaz.orderby==="asc"?"desc":"asc"})}>Država{getOrderImage("drzava")}</Th>
                                    
                                </Tr>
                            </Thead>
                            <Tbody>
                            {prikaz.osobeprikaz.slice((prikaz.currpage-1)*prikaz.rowsperpage,(prikaz.currpage)*prikaz.rowsperpage).map((item,i)=>{
                                return (
                                    <Tr  color={'grunt2'} key={item.id}  bg={'white'} fontWeight={'normal'} fontSize={size} 
                                    _hover={{bg:'gray.100',cursor:'pointer'}} onClick={(e)=>SelectOsoba(item)} h='2rem'>
                                        <Td><Badge size={'xs'} fontWeight={'normal'} variant={'solid'} colorScheme={colorSchmemes[(item.drzava_sifra.charCodeAt(0))%16]}>{item.drzava_sifra}</Badge></Td>
                                        <Td textAlign={'center'}>{item.sifra}</Td>
                                        <Td textAlign={'center'}>{item.naziv}</Td>
                                        <Td textAlign={'center'}>{item.mjesto}</Td>
                                        <Td textAlign={'center'}>{item.ulkbr}</Td>
                                        <Td textAlign={'center'}>{item.pbr}</Td>
                                        <Td textAlign={'center'}>{item.posta}</Td>
                                        <Td textAlign={'center'}>{item.drzava}</Td>
                                    </Tr>
                                )
                            })}
                            </Tbody>
                            </Table>
                    </TableContainer>
                    
                </Box>
                {/* <Spacer/> */}
                {getFooter()}
            
            {UnosNoveOsobe()}
            {EditOsobe()}

        </Box>
        
        
    );
}

export default Osobe;